module.exports = __webpack_public_path__ + "img/total_posts.1a2dcea9.svg";